import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';

const variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
    },
  },
};

const AnimatedFeature = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 0px 0px" });
  const controls = useAnimation();

  useEffect(() => {
    // Detect mobile device
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768 || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (isMobile) {
      // On mobile, immediately show content without animation
      controls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 0 }
      });
    } else if (isInView) {
      // On desktop, use normal animation
      controls.start({
        ...variants.visible,
        transition: {
          ...variants.visible.transition,
          delay: delay * 0.1,
        },
      });
    }
  }, [isInView, controls, delay, isMobile]);

  // For mobile, start visible. For desktop, start hidden.
  const initialState = isMobile ? "visible" : "hidden";

  return (
    <motion.div
      ref={ref}
      initial={initialState}
      animate={controls}
      variants={variants}
      style={{ willChange: 'transform' }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedFeature;
